// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/custom-text.scss
// module id = 65
// module chunks = 0